// extracted by mini-css-extract-plugin
module.exports = {"bp-min-sm":"(min-width: 520px)","container":"VenueFooter-module--container--ae6365","logo":"VenueFooter-module--logo--97d24f"};